import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core'
import { LoadScrollService } from 'dmmp-services'

@Component({
  selector: 'dmmp-desktop',
  templateUrl: './desktop.component.html'
})
export class DesktopComponent implements OnInit {

  @Input() data
  cards = []
  @Input() itemByRow
  @Output() page = new EventEmitter()

  constructor(
    private loadScroll: LoadScrollService
  ) { }

  ngOnInit(): void {
    this.scrollEvent()
  }

  scrollEvent() {
    this.loadScroll.loadScroll(this.data.content, this.itemByRow, this.cards)
  }

}
